export default {
  // Common / Navigation
  site_name: "CSSBuyBR",
  nav_spreadsheet: "CSSBuy Spreadsheet",
  nav_categories: "Categories",
  nav_guides: "Guides",
  nav_reviews: "Reviews",
  nav_shipping: "Shipping",
  nav_safety: "Safety",
  nav_home: "Home",
  nav_shopping_guide: "Shopping Guide",
  nav_about: "About",
  language: "Language",
  lang_pt: "Português",
  lang_de: "Deutsch",
  lang_en: "English",
  open_spreadsheet: "Open Spreadsheet",
  main_cta: "CSSBuy Spreadsheet",
  buy_now: "Buy It Now",
  search_placeholder: "Search CSSBuy Spreadsheet...",
  updated: "Updated",
  independent_notice: "Independent Resource",
  disclaimer_short: "Not the official CSSBuy website",
  read_more: "Read more",
  explore: "Explore",
  learn_more: "Learn more",
  back_to_home: "Back to Home",
  related_articles: "Related Articles",
  table_of_contents: "Table of Contents",
  author: "Author",
  published: "Published",
  last_updated: "Last updated",
  quick_answer: "Quick Answer",
  conclusion: "Conclusion",
  faq: "Frequently Asked Questions",
  pros: "Pros",
  cons: "Cons",
  step_by_step: "Step by Step",
  what_youll_learn: "What you will learn",
  trust_badge: "Independent information • Practical guides • Organized data",
  safety_cta: "CSSBuy Safety Guide",
  footer_about: "About",
  footer_safety: "Safety",
  footer_disclaimer: "Disclaimer",
  footer_privacy: "Privacy",
  footer_terms: "Terms",
  footer_contact: "Contact",
  footer_resources: "Resources",
  footer_copyright: "© 2026 CSSBuyBR.info. Independent resource — not the official CSSBuy website.",
  disclaimer_full: "CSSBuyBR.info is an independent informational resource and is not the official CSSBuy website. We do not process payments, sell products, or have any affiliation with CSSBuy. Always verify important account, payment, shipping, and policy information through official channels before taking action.",
  
  // Hero
  hero_eyebrow: "CSSBUY • SPREADSHEET • BUYING GUIDES",
  hero_title: "CSSBuy Spreadsheet: Find Products and Buy with More Confidence",
  hero_subtitle: "Explore a CSSBuy Spreadsheet organized by categories and find practical guides on products, QC, storage, shipping costs, coupons, and the buying process.",
  hero_cta_primary: "Explore CSSBuy Spreadsheet",
  hero_cta_secondary: "View CSSBuy Guides",
  hero_trust: "Independent resources • Practical guides • Organized information",
  
  // Categories Section
  categories_title: "Product Categories",
  categories_subtitle: "Browse popular categories and find what you are looking for in the CSSBuy Spreadsheet.",
  category_shoes: "Shoes",
  category_hoodies: "Hoodies/Sweaters",
  category_tshirts: "T-Shirts",
  category_jackets: "Jackets",
  category_pants: "Pants/Shorts",
  category_headwear: "Headwear",
  category_sets: "Sets",
  category_underwear: "Underwear",
  category_jersey: "Jerseys",
  category_accessories: "Accessories",
  category_bags: "Bags",
  category_belts: "Belts",
  category_perfumes: "Perfumes",
  category_other: "Other Stuff",
  
  // Spreadsheet Section
  spreadsheet_title: "CSSBuy Spreadsheet in One Place",
  spreadsheet_desc: "Finding products can be difficult when information is scattered across different sources. Our goal is to organize categories, resources, and guides related to CSSBuy Spreadsheet to make your research simpler and help you make more informed decisions.",
  spreadsheet_card_products: "Products",
  spreadsheet_card_products_desc: "Explore organized products and categories.",
  spreadsheet_card_guides: "Guides",
  spreadsheet_card_guides_desc: "Learn how to research, compare, and verify information.",
  spreadsheet_card_shipping: "Shipping",
  spreadsheet_card_shipping_desc: "Understand costs, weight, options, and factors that influence shipping.",
  spreadsheet_card_safety: "Safety",
  spreadsheet_card_safety_desc: "Learn to identify links, offers, and potentially suspicious information.",
  spreadsheet_cta: "Explore categories",
  
  // How It Works
  how_title: "How to Use a CSSBuy Spreadsheet",
  how_step1_title: "Find a Product",
  how_step1_desc: "Search by category and identify relevant options.",
  how_step2_title: "Verify Information",
  how_step2_desc: "Check links, images, measurements, and available details.",
  how_step3_title: "Compare Options",
  how_step3_desc: "Consult QC and compare different alternatives.",
  how_step4_title: "Make Your Decision",
  how_step4_desc: "Confirm prices, policies, and current information before buying.",
  how_cta: "Open CSSBuy Spreadsheet",
  
  // Popular Topics
  topics_title: "Everything You Need to Know About CSSBuy",
  topic_review_title: "CSSBuy Review",
  topic_review_desc: "See how it works, key features, limitations, and important factors.",
  topic_shipping_title: "CSSBuy Shipping Cost",
  topic_shipping_desc: "Understand the main factors that influence final shipping costs.",
  topic_coupon_title: "CSSBuy Coupon",
  topic_coupon_desc: "Learn how to find and verify current offers.",
  topic_discount_title: "CSSBuy Discount Code",
  topic_discount_desc: "Learn how to verify codes and conditions before using them.",
  topic_warehouse_title: "CSSBuy Warehouse",
  topic_warehouse_desc: "Understand storage, QC, and order preparation.",
  topic_legit_title: "CSSBuy Legit",
  topic_legit_desc: "Learn the key points that should be analyzed before using any service.",
  
  // Trust Section
  trust_title: "Information Before You Buy",
  trust_desc: "CSSBuyBR.info is an independent resource. We are not the official CSSBuy website, we do not process payments, and we do not sell products. Our goal is to organize useful information for research, comparison, and consumer education.",
  
  // Final CTA
  final_cta_title: "Ready to Explore CSSBuy Spreadsheet?",
  final_cta_desc: "Start with a category, check our guides, and always confirm current information before making a purchase.",
  final_cta_primary: "Explore CSSBuy Spreadsheet",
  final_cta_secondary: "Visit Main Website",
  
  // Article Page
  article_intro: "Introduction",
  article_what_is: "What is CSSBuy Spreadsheet",
  article_how_to_use: "How to Use CSSBuy Spreadsheet",
  article_categories: "Main Categories",
  article_shipping: "Shipping and Costs",
  article_qc: "QC and Verification",
  article_tips: "Practical Tips",
  article_comparison: "Comparison with Alternatives",
  article_safety: "Safety and Precautions",
  article_conclusion: "Conclusion",
  
  // Meta
  meta_home_title: "CSSBuy Spreadsheet: Find Products, Guides & Buying Resources",
  meta_home_desc: "Explore an organized CSSBuy Spreadsheet with products, categories, guides, QC, shipping, coupons, and safety information to make your research easier.",
  meta_article_title: "CSSBuy Spreadsheet: Complete Guide to Finding and Comparing Products",
  meta_article_desc: "Complete CSSBuy Spreadsheet guide. Learn how to research, compare categories, verify QC, and understand shipping costs to buy with more confidence.",
  
  // Category URLs (same external URLs)
  cat_url_shoes: "https://kaspreadsheet.com/category-911-Shoes.html",
  cat_url_hoodies: "https://kaspreadsheet.com/search-912/name/Shoes.html",
  cat_url_tshirts: "https://kaspreadsheet.com/search-913/name/Shoes.html",
  cat_url_jackets: "https://kaspreadsheet.com/search-914/name/Shoes.html",
  cat_url_pants: "https://kaspreadsheet.com/search-915/name/Shoes.html",
  cat_url_headwear: "https://kaspreadsheet.com/search-916/name/Shoes.html",
  cat_url_sets: "https://kaspreadsheet.com/search-917/name/Shoes.html",
  cat_url_underwear: "https://kaspreadsheet.com/search-918/name/Shoes.html",
  cat_url_jersey: "https://kaspreadsheet.com/search-919/name/Shoes.html",
  cat_url_accessories: "https://kaspreadsheet.com/search-920/name/Shoes.html",
  cat_url_bags: "https://kaspreadsheet.com/search-921/name/Shoes.html",
  cat_url_belts: "https://kaspreadsheet.com/search-922/name/Shoes.html",
  cat_url_perfumes: "https://kaspreadsheet.com/search-923/name/Shoes.html",
  cat_url_other: "https://kaspreadsheet.com/search-924/name/Shoes.html",
  main_site_url: "https://kaspreadsheet.com",
};